export default "__VITE_ASSET__Do8rJpEw__"